import $ from 'jquery';

$(document).ready(function () {

    var ajaxurl = $('#ajaxurl').attr('ajaxurl');

    if ($('.partnerji_block').length) {
        $('.load_more_partnerji > p').on('click', function () {
            $(this).hide();
        })

        $(".load_more_partnerji").click(function (event) {
            event.preventDefault();
            $.ajax({
                type: "post",
                url: ajaxurl,
                data: {
                    action: "load_more_partnerji",
                    show: $(this).attr("data")
                },
                success: function (result) {
                    $(".load_more_partnerji").html(result)
                },
                error: function () {
                    console.log("Ajax error");
                }
            })
        })
    }

    $('form.filter-produktov-inner .single_kategorija input:checkbox').on('click', function () {
        $(this).toggleClass('checked');
        //uncheck parent category if checking a child category and apply right filters
        if ($(this).parent().hasClass('child_term')) {
            $(this).closest('.child_wrap').siblings('.parent_term_wrapper').find('input').toggleClass('checked');

            let value = $(this).closest('.child_wrap').prev('.parent_term_wrapper').find('input').val();

            $("#filter-produktov-outer input").each(function () {

                if (value === $(this).attr('value')) {
                    $(this).removeClass('filter-tag-active');
                    $('.filter-tags .tag' + value).remove()
                }
            });

            $(this).closest('.child_wrap').siblings('.parent_term_wrapper').find('input').prop("checked", false);
            $(this).closest('.child_wrap').siblings('.parent_term_wrapper').find('.parent_term div').removeClass('active');

        } else if ($(this).parent().hasClass('grandchild_term')) {
            $(this).closest('.grandchild_wrap').prev('.child_input_label_wrap').toggleClass('checked');
            $(this).closest('.grandchild_wrap').prev('.child_input_label_wrap').find('input').prop("checked", false);

            let value = $(this).closest('.grandchild_wrap').prev('.child_input_label_wrap').find('input').val();

            $("#filter-produktov-outer input").each(function () {

                if (value === $(this).attr('value')) {
                    $(this).removeClass('filter-tag-active');
                    $('.filter-tags .tag' + value).remove()
                }
            });

        }
        let chosenFilters = getFilters();
        AjaxProducts(chosenFilters, 1);
    })


    $('#list-filtriranih-produktov').on('click', '.page-numbers', function (event) {
        event.preventDefault();
        var pageNum = $(this).text();

        let chosenFilters = getFilters();
        AjaxProducts(chosenFilters, pageNum);
    });

    // $('form.filter-produktov-inner button:submit').click(function (event) {
    //     event.preventDefault();
    //
    //     let chosenFilters = getFilters();
    //     AjaxProducts(chosenFilters, 1);
    //
    // })

    function getFilters() {
        let chosenFilters = [];

        $('.single_kategorija').each(function () {
            let taxonomy = $(this).data('tax');
            let chosenTerm = [];

            $(this).find('input:checked').each(function () {
                chosenTerm.push($(this).attr("value"));
            })
            if (chosenTerm.length > 0) {
                chosenFilters.push({label: taxonomy, data: chosenTerm});
            }
        });

        return chosenFilters;
    }

    function AjaxProducts(filtri, page) {
        $("#list-filtriranih-produktov").addClass("loading");
        $.ajax({
            type: "post",
            url: ajaxurl,
            data: {
                action: "returnProduktiFilter",
                ids: JSON.stringify(filtri),
                page: page,
            },
            success: function (event) {
                $("#list-filtriranih-produktov").removeClass("loading");
                $('#list-filtriranih-produktov').html(event);
            },
            error: function () {
                $("#list-filtriranih-produktov").removeClass("loading");
                console.log('Error');
            }
        });
    }

});